exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".c-image {\n  height: 100%; }\n\n.c-image__img {\n  height: 100%;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/content-types/image/image.scss
// module id = 430
// module chunks = 0